import { useCallback } from 'react';
import { DashboardType } from '@/config/dashboardWorkflows';
import { useTaskStageUpdate } from './useTaskStageUpdate';

interface DraggableCard {
  taskId: string;
  id: string;
  taskIdNum?: number;
  stage: number;
}

export function useDashboardDragDrop(dashboardType: DashboardType) {
  const updateStageMutation = useTaskStageUpdate();

  const handleCardDrop = useCallback(async (
    e: React.DragEvent,
    taskId: string,
    newStage: number,
    tasks: DraggableCard[]
  ) => {
    e.preventDefault();

    const task = tasks.find(t => t.taskId === taskId || t.id === taskId);
    if (!task) return;
    if (!task.taskIdNum) return;
    if (task.stage === newStage) return;

    updateStageMutation.mutate({
      taskId: task.taskIdNum,
      stage: newStage,
      dashboardType,
    });
  }, [dashboardType, updateStageMutation]);

  const handleCardDragStart = useCallback((e: React.DragEvent, taskId: string, stage: number) => {
    e.dataTransfer.setData('taskId', taskId);
    e.dataTransfer.setData('stage', stage.toString());
  }, []);

  return { handleCardDrop, handleCardDragStart };
}
